import { z } from 'zod';

import type { Mutation } from './common';
import { idSchema } from './id';
import { skillShortSchema } from './skill';

type SkillIdsField = {
    readonly skillIds: readonly string[];
};

export const courseHistoryItemSchema = z.object({
    id: z.string(),
    courseTitle: z.string(),
    dateFrom: z.string().optional(),
    dateTo: z.string().optional(),
    description: z.string().optional(),
    ongoing: z.boolean().optional(),
    school: z.string().optional(),
    skills: skillShortSchema.array().optional(),
});

export const courseHistoryItemArraySchema = courseHistoryItemSchema.array();

export type CourseHistoryItem = z.infer<typeof courseHistoryItemSchema>;

export const courseHistoryCreationSchema = courseHistoryItemSchema
    .omit({ id: true, skills: true })
    .extend({ skillIds: idSchema.array().optional() });
export type CourseHistoryCreation = z.infer<typeof courseHistoryCreationSchema>;

export type CourseHistoryMutation = Mutation<CourseHistoryItem> &
    Pick<CourseHistoryItem, 'courseTitle' | 'id'> &
    SkillIdsField;
